// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"580ba47e","243":"8e4ffa35","393":"9f3eff40","447":"ecdfc9af","453":"1deffb67","682":"e1710699","732":"738ebdbb","828":"b2f7e044","967":"b8072f7c","977":"29e78813"}[chunkId] + ".chunk.js";
};